import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  RegistrationInquiryMessage,
  RegistrationInquiryStartResult,
} from '../models/RegistrationInquiry';

@Injectable({
  providedIn: 'root',
})
export class RegistrationInquiryService {
  private readonly urlPath = 'registration-inquiries';

  constructor(private httpClient: HttpClient) {}

  startInquiry(
    guestName: string,
    guestEmail: string,
    text: string,
  ): Observable<RegistrationInquiryStartResult> {
    return this.httpClient.post<RegistrationInquiryStartResult>(
      `${environment.apiUrl}${this.urlPath}`,
      { guestName, guestEmail, text },
    );
  }

  getMessages(
    inquiryId: string,
    guestToken: string,
  ): Observable<RegistrationInquiryMessage[]> {
    return this.httpClient.get<RegistrationInquiryMessage[]>(
      `${environment.apiUrl}${this.urlPath}/${inquiryId}/messages`,
      { params: new HttpParams().set('guestToken', guestToken) },
    );
  }

  sendMessage(
    inquiryId: string,
    guestToken: string,
    text: string,
    attachment?: File | null,
  ): Observable<RegistrationInquiryMessage> {
    const params = new HttpParams().set('guestToken', guestToken);
    const url = `${environment.apiUrl}${this.urlPath}/${inquiryId}/messages`;
    if (attachment) {
      const formData = new FormData();
      formData.append('model', JSON.stringify({ text }));
      formData.append('file', attachment, attachment.name);
      return this.httpClient.post<RegistrationInquiryMessage>(url, formData, { params });
    }
    return this.httpClient.post<RegistrationInquiryMessage>(url, { text }, { params });
  }

  setReaction(
    inquiryId: string,
    guestToken: string,
    messageId: number,
    reaction: string | null,
  ): Observable<RegistrationInquiryMessage> {
    return this.httpClient.put<RegistrationInquiryMessage>(
      `${environment.apiUrl}${this.urlPath}/${inquiryId}/messages/${messageId}/reaction`,
      { reaction },
      { params: new HttpParams().set('guestToken', guestToken) },
    );
  }

  markMessagesRead(inquiryId: string, guestToken: string): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.apiUrl}${this.urlPath}/${inquiryId}/messages/read`,
      {},
      { params: new HttpParams().set('guestToken', guestToken) },
    );
  }

  getUnreadCount(inquiryId: string, guestToken: string): Observable<number> {
    return this.httpClient.get<number>(
      `${environment.apiUrl}${this.urlPath}/${inquiryId}/messages/unread-count`,
      { params: new HttpParams().set('guestToken', guestToken) },
    );
  }
}
